/**
 * Calls the specified callback function for all the elements in an array.
 * The return value of the callback function is the accumulated result,
 * and is provided as an argument in the next call to the callback function.
 * The function returns an array with all values produced by the callback.
 *
 * example:
 * ```
 * const sum = (acc, value) => acc + value;
 * const cumulativeSum = scan([1,2,3,4], sum, 0)
 * cumulativeSum // [1,3,6,10]
 * ```
 * @param callbackfn A function that accepts up to four arguments.
 * The reduce method calls the callbackfn function one time for each element in the array.
 *
 * @param initialValue  initialValue is used as the
 * initial value to start the accumulation.
 *
 * @see http://zvon.org/other/haskell/Outputprelude/scanl1_f.html
 */
export function scan<T = any, U = T>(
  array: T[],
  callbackfn: (previousValue: U, currentValue: T, currentIndex: number, array: T[]) => U,
  initialValue: U
): U[] {
  const res: U[] = []
  let accumulator = initialValue
  for (let i = 0; i < array.length; i++) {
    accumulator = callbackfn(accumulator, array[i], i, array)
    res.push(accumulator)
  }
  return res
}

export function sortArrayOfObjsBasedOnArray<T, K extends keyof T>(
  dataset: T[],
  columnName: K,
  sortedArray: T[K][]
) {
  return dataset.sort(
    (a, b) => sortedArray.indexOf(a[columnName]) - sortedArray.indexOf(b[columnName])
  )
}
